<template>
	<div>
		<page-header></page-header>
		<div class="jumbotron jumbotron-fluid">
			<div class="container">
				<h1 class="display-4">{{"Coming Soon..."}}</h1>
				<p class="lead">
					{{"These tracks will be uploaded when the subscription service is put in place."}}
				</p>
			</div>
		</div>
		<page-footer class="fixed-bottom"></page-footer>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	setup()
	{
		return {
		};
	},
});
</script>

<style scoped>
</style>
